import { render, staticRenderFns } from "./logisticsInformation.vue?vue&type=template&id=3a5fb325"
import script from "./logisticsInformation.vue?vue&type=script&lang=js"
export * from "./logisticsInformation.vue?vue&type=script&lang=js"
import style0 from "./logisticsInformation.vue?vue&type=style&index=0&id=3a5fb325&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5fb325')) {
      api.createRecord('3a5fb325', component.options)
    } else {
      api.reload('3a5fb325', component.options)
    }
    module.hot.accept("./logisticsInformation.vue?vue&type=template&id=3a5fb325", function () {
      api.rerender('3a5fb325', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/productDetail/logisticsInformation.vue"
export default component.exports